import React from 'react';
import { useTranslation } from '../i18n/LanguageContext';

const ProcessSection = () => {
  const { t } = useTranslation();
  
  const steps = [
    { step: '01', title: t('process.steps.step1.title'), body: t('process.steps.step1.body') },
    { step: '02', title: t('process.steps.step2.title'), body: t('process.steps.step2.body') },
    { step: '03', title: t('process.steps.step3.title'), body: t('process.steps.step3.body') },
    { step: '04', title: t('process.steps.step4.title'), body: t('process.steps.step4.body') },
    { step: '05', title: t('process.steps.step5.title'), body: t('process.steps.step5.body') },
    { step: '06', title: t('process.steps.step6.title'), body: t('process.steps.step6.body') }
  ];

  return (
    <section id="ablauf" className="section-spacing-large bg-white">
      <div className="container-cift">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="gold-accent mx-auto" />
          <h2 className="section-title mb-6">
            {t('process.headline')}
          </h2>
          <p className="subtitle">
            {t('process.body')}
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="relative group"
              >
                {/* Step Number */}
                <div className="mb-4">
                  <span className="inline-block text-6xl font-display font-bold text-gold/20 group-hover:text-gold/40 transition-colors">
                    {step.step}
                  </span>
                </div>

                {/* Content */}
                <div className="border-l-2 border-gray-200 pl-6 pb-8 group-hover:border-gold transition-colors">
                  <h3 className="text-xl font-display font-bold mb-3 text-gray-900">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {step.body}
                  </p>
                </div>

                {/* Connector Line (hidden on last item in row) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 -right-4 w-8 h-0.5 bg-gray-200" />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-cream p-12 rounded-lg">
          <h3 className="text-2xl font-display font-bold mb-4">
            {t('process.ctaBox.headline')}
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            {t('process.ctaBox.body')}
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('kontakt');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-primary"
          >
            {t('process.ctaBox.cta')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
